import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useRefresh, useNotify, useMutation, Button } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";

interface IInactivateSchoolButton {
  schoolId: string;
}

const CustomConfirmButton = ({ schoolId }: IInactivateSchoolButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleChangeStatusSchool, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `schools/${schoolId}/inactivate`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully inactivate school.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed inactivate the school, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleChangeStatusSchool}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const InactivateSchoolButton = ({ schoolId }: IInactivateSchoolButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    table: {
      marginTop: "10px",
      minWidth: 650,
      padding: "1rem",
    },
  });

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        label={`Inactivate School`}
        onClick={handleOpenDialog}
        style={{ backgroundColor: "#f44336" }}
      />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Inactivate The School</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            This action will inactive all the students of this school, Are you
            sure you want to Inactive the school?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton schoolId={schoolId} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default InactivateSchoolButton;
